// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Wo-z","slideIn":"Xo-z"};